import { render, staticRenderFns } from "./ProductSelection.vue?vue&type=template&id=e8ccc678&scoped=true"
import script from "./ProductSelection.vue?vue&type=script&lang=js"
export * from "./ProductSelection.vue?vue&type=script&lang=js"
import style0 from "./ProductSelection.vue?vue&type=style&index=0&id=e8ccc678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ccc678",
  null
  
)

export default component.exports